// Reference:
// * https://github.com/epicweb-dev/epic-oidc/blob/3ec86a25ee532c48e8b541e1c542bac736c8cf29/app/utils/misc.tsx

import { useFormAction, useNavigation } from "react-router";

// Check if the current navigation is in the process of submitting the current
// route's form.
//
// NOTE: The default formAction will include query params, but
// navigation.formAction will not. Therefore, don't use the default formAction
// if you want to know if a form is submitting without specific query params.
//
export function useIsPending({
  formAction,
  formMethod = "POST",
  state = "non-idle",
}: {
  formAction?: string;
  formMethod?: "POST" | "GET" | "PUT" | "PATCH" | "DELETE";
  state?: "submitting" | "loading" | "non-idle";
} = {}) {
  const contextualFormAction = useFormAction();
  const navigation = useNavigation();
  const isPendingState =
    state === "non-idle"
      ? navigation.state !== "idle"
      : navigation.state === state;

  return (
    isPendingState &&
    navigation.formAction === (formAction ?? contextualFormAction) &&
    navigation.formMethod === formMethod
  );
}
